export type MeetingGuest = { email: string; name: string };

export type CollectedMeeting = {
  isNew: boolean;
  title: string;
  time: string;
  guests: MeetingGuest[];
  domains: string[];
  calendarOwnerDomain?: string;
  meetingBriefUrls?: Record<string, string>;
};

export enum Calendar {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  google = 'google',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  outlook = 'outlook',
}

export type CollectedEmail = Partial<{
  subject: string;
  recipientsEmails: string[];
  recipientsDomains: string[];
  senderEmails: string[];
  senderDomains: string[];
  instanceId?: string;
  replyToEmails?: string[];
  replyToDomains?: string[];
}>;
